import type { FC, ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'
import type { ActivityType } from '@/types'

import {
    CircleX,
    FileText,
    Hourglass,
    Receipt,
    TrendingDown,
    TrendingUp,
    TriangleAlert,
    UserMinus,
    UserPlus,
    UsersRound
} from 'lucide-react'

import { cn } from '@/lib/utils'

interface ActivityIconProps {
    type: ActivityType
    className?: string
}

const STYLES: Record<ActivityType, { icon: LucideIcon, className: string }> = {
    upgrade: { icon: TrendingUp, className: 'bg-success/12 text-success' },
    downgrade: { icon: TrendingDown, className: 'bg-warning/12 text-warning' },
    new: { icon: UserPlus, className: 'bg-info/12 text-info' },
    trial: { icon: Hourglass, className: 'bg-info/12 text-info' },
    payment: { icon: Receipt, className: 'bg-success/12 text-success' },
    'payment-failed': { icon: CircleX, className: 'bg-destructive/12 text-destructive' },
    churn: { icon: UserMinus, className: 'bg-warning/12 text-warning' },
    risk: { icon: TriangleAlert, className: 'bg-warning/12 text-warning' },
    team: { icon: UsersRound, className: 'bg-muted text-muted-foreground' },
    report: { icon: FileText, className: 'bg-muted text-muted-foreground' }
}

export const ActivityIcon: FC<ActivityIconProps> = ({ type, className }): ReactNode => {
    const { icon: Icon, className: tone } = STYLES[type]

    return (
        <span className={cn('flex size-8 shrink-0 items-center justify-center rounded-lg', tone, className)} aria-hidden='true'>
            <Icon className='size-4' />
        </span>
    )
}
